module.exports = __webpack_public_path__ + "assets/img/welfare-img3-562f1209.jpg";